export default {
  finance: {
    general: {
      active: 'Aktif',
      passive: 'Pasif'
    }
  },
  advantage: {
    organization: 'Birim Şube',
    employee: 'Çalışan',
    quota: 'Kota',
    quotaLeft: 'Kalan Kota',
    enterQuota: 'Kota Giriniz...',
    validateQuota: 'Geçerli Bir Kota Değeri Giriniz...',
    positionType: 'Görev',
    deliveryDate: 'Erken Teslim Avantajı',
    workingCostRatio: 'Organizasyon Ücreti İndirimi',
    timeFrame: 'Geçerlilik Tarihi',
    startDate: 'Başlangıç Tarihi',
    endDate: 'Bitişi Tarihi',
    saveAdvantageFormTitle: 'Yeni Kayıt Ekle',
    saveAdvantageEditFormTitle: 'Avantaj Kaydı Güncelle',
    month: 'Ay',
    advantagePartyType: 'Grup Türü',
    partyName: 'Avantaj Sahibi',
    deleteText: 'Kaydı silmek istediğinizden emin misiniz?',
    deleteTitle: 'Avantaj Kaydı Silme',
    validateAdvantageParty: 'En az bir kayıt seçmelisiniz.',
    validateRatio: 'Sıfırdan büyük değer giriniz.',
    validateDate: 'Geçerlilik tarih aralığı başlangıç bitişten sonra olamaz.',
    dateRequired: 'Zorunlu alan...'
  },
  sale: {
    workingCostAdvancePayment: 'Organizasyon Ücreti Peşinatı',
    customerName: 'Müşteri Adı',
    paymentDay: 'Ödeme Günü',
    paymentStartDate: 'Taksit Başlangıç Tarihi',
    personalName: 'Personal',
    financialCalculationParameters: 'Finansman Hesaplama Parametreleri',
    afterDeliveryInstallmentAmount: 'Teslim Sonrası Taksit Tutarı',
    financeType: 'Lütfen Finansman içeriğini seçiniz.',
    methodType: 'Yöntem Türü',
    acceptSale: 'Satışı yapmak istediğinize emin misiniz?',
    sale: 'Satış',
    financeAmount: 'Finansman Tutarı',
    installmentAmount: 'Taksit Tutarı',
    alreadyExist: 'Aynı özelliklere sahip kayıt tekrar eklenemez.',
    firstPaymentAmount: 'Peşinat Tutarı',
    suggestedGroup: 'Sizin için önerdiğimiz gruplardan uygun gördüğünüzü seçiniz.',
    income: 'Gelir',
    inflation: 'Yıllık Artış',
    // suggestedGroup: 'Önerilen Gruplar',
    calculatedMinWorkingCostAmount: 'Organizasyon Ücreti',
    calculatedMaxWorkingCostAmount: 'Maximum İlk Ödeme',
    totalInterimPayment: 'Toplam Ara Ödeme',
    findGroup: 'Grupları Bul',
    calculate: 'Hesapla',
    workingCostAmount: 'Organizasyon Ücreti Tutarı',
    version: 'Versiyon',
    advanceAmount: 'Peşinat Tutarı',
    deliveryDate: 'Tahsisat Tarihi',
    totalMonth: 'Toplam Taksit',
    actions: 'İşlemler',
    paymentTable: 'Ödeme Tablosu',
    compareTable: 'Karşılaştırma',
    saveProposal: 'Teklif Kaydet',
    saveProduct: 'Finansman Planı Kaydet',
    financeTypeValidation: 'Finansman Türü seçiniz.',
    methodTypeValidation: 'Yöntem Türü seçiniz.',
    zeroValueValidation: 'Sıfırdan farklı bir değer giriniz',
    campaignList: {
      name: 'Kampanya Adı',
      campaignType: 'Kampanya Tipi',
      value: 'Değer',
      workingCostRatio: 'Organizasyon Ücreti',
      deliveryDate: 'Teslim Avantajı'
    }
  },
  campaign: {
    list: {
      campaignName: 'Kampanya Adı',
      image: 'Resim',
      quota: 'Kota',
      minLimit: 'Alt Sınır',
      maxLimit: 'Üst Sınır',
      workingCost: 'Organizasyon Ücreti',
      deliveryDate: 'Tahsisat Tarihi',
      startDate: 'Başlangıç',
      endDate: 'Bitiş',
      actions: 'İşlemler',
      newCampaign: 'Kampanya Oluştur'
    },
    usageList: {
      usageView: 'Kullanım Listeleri',
      campaignUsageList: 'Kampanya Kullanım Listesi',
      employeeAdvantageUsageList: 'Çalışan Avantaj Kullanım Listesi',
      packageUsageList: 'Paket Kullanım Listesi',
      typeSomething: 'Arama Yapınız...',
      referenceRuleUsageList: 'Referans Kullanım Listesi',
      workingCostRatio: 'Çalışma (Oranı% - Değeri)',
      deliveryDateRatio: 'Tahsisat Tarihi (Oranı% - Değeri)',
      campaignName: 'Kampanya Adı',
      customerName: 'Müşteri Adı',
      referenceCount: 'Referans Sayısı',
      campaignType: 'Kampanya Tipi',
      packageName: 'Paket Adı',
      typeName: 'Tip',
      validDate: 'Teklif Geçerlilik Tarihi',
      advanceUsageList: 'Peşinat Avantajı Listesi',
      userName: 'Çalışan Adı',
      financeAmount: 'Finans Tutarı',
      financeType: 'Finans Tipi',
      methodType: 'Method Türü',
      usage: 'Kullanım',
      advantagePartyType: 'Avantaj Parti Türü',
      advantageParty: 'Avantaj Parti',
      proposalDate: 'Teklif Tarihi',
      productDate: 'Plan Tarihi',
      status: 'Durum',
      partyName: 'Müşteri Adı',
      definitionName: 'Tanım',
      order: 'Sıra',
      quotaRatio: 'Kota Oranı',
      proposalStatus: 'Teklif Durumu',
      productStatus: 'Finansman Planı Durumu',
      referanceCount: 'Referans Sayısı',
      no: 'No',
      proposalNo: 'Teklif No',
      appliedAdvantageNo: 'Kullanılan Avantaj No',
      appliedMonth: 'Uygulanan Ay',
      appliedRatio: 'Kullanılan Oran',
      isItProduct: 'Finansman Planı mı?',
      product: 'Finansman Planı',
      proposal: 'Teklif'
    },
    create: {
      campaignCategory: 'Kategori listesi boş olduğundan kampanya tanımlayamazsınız. Önce kategori tanımlayınız.',
      campaignCategories: 'Kampanya Kategorileri:',
      campaignName: 'Kampanya Adı',
      dateRange: 'Tarih Aralığı',
      minLimit: 'En Düşük Limit',
      maxLimit: 'En Yüksek Limit',
      chooseStartDate: 'Başlangıç Tarihi Seçiniz',
      chooseEndDate: 'Bitiş Tarihi Seçiniz',
      chooseFile: 'Dosya Seçiniz',
      campaignQuota: 'Kampanya Kotası',
      workingCost: 'Organizasyon Ücreti',
      deliveryDate: 'Tahsisat Tarihi',
      properties: 'Özellikler',
      canUseInitiative: 'İnisiyatif kullanılabilir',
      campaignNameMessage: 'Kampanya Adı giriniz!',
      minLimitMessage: 'Minimum Tutar giriniz!',
      maxLimitMessage: 'Maximum Tutar giriniz!',
      startDateMessage: 'Başlangıç Tarihi seçiniz!',
      endDateMessage: 'Bitiş Tarihi seçiniz!',
      user: 'Kullanıcı',
      proposalNo: 'Teklif No',
      appliedMonth: 'Uygulanan Ay',
      appliedRatio: 'Kullanılan Oran',
      isItProduct: 'Finansman Planı mı?',
      product: 'Finansman Planı',
      proposal: 'Teklif',
      campaignImageMessage: 'Kampanya Resmi giriniz!'
    },
    placeholder: {
      enterCampaignName: 'Kampanya Adı Giriniz',
      chooseCategory: 'Kategori Seçiniz',
      chooseStartDate: 'Başlangıç Tarihi Seçiniz',
      chooseEndDate: 'Bitiş Tarihi Seçiniz'
    }
  },
  category: {
    list: {
      addProductCategory: 'Finansman Planı Kategorisi Ekle',
      productCategory: 'Finansman Planı Kategorisi Kodu',
      productMainCategory: 'Finansman Planı Ana Kategorisi',
      value: 'Değer',
      productValue: 'Finansman Planı Değeri',
      productsMainCategory: 'Ürünün Ana Kategorisi',
      code: 'Kategori Kodu',
      parentCode: 'Kategori Ana Kodu',
      userCode: 'Kullanıcı Kodu',
      date: 'Tarih',
      actions: 'İşlemler'
    }
  },
  limit: {
    list: {
      addAdvantageToPersonal: 'Personele Avantaj Ekle',
      addingAdvantageToPersonal: 'Personele Avantaj Ekleme',
      limitName: 'Tanım Adı',
      userCode: 'Kullanıcı Kodu',
      usableRatio: 'Kullanılabilir Oran',
      ratio: 'Oran',
      usableMonth: 'Kullanılabilir Ay',
      customerCount: 'Müşteri Sayısı',
      no: 'No',
      staffCode: 'Personel Kodu',
      totalCustomer: 'Toplam Müşteri',
      remainCustomerCount: 'Kalan Müşteri',
      totalMonth: 'Toplam Ay',
      remainMonthCount: 'Kalan Ay',
      startDate: 'Başlangıç',
      endDate: 'Bitiş'
    },
    usageList: {
      no: 'No',
      customerNo: 'Müşteri No',
      proposalNo: 'Teklif No',
      userCode: 'Kullanan Personel',
      usedRatio: 'Kullanılan Oran',
      usedMonth: 'Kullanılan Ay',
      isItProduct: 'Finansman Planı mı?'
    },
    placeholder: {
      enterLimitName: 'Limit Adı Giriniz'
    }
  },
  product: {
    freeplanTitle: 'Müşteri Bazlı Yöntem',
    orderedTitle: 'Çekilişli Yöntem',
    list: {
      customerNo: 'Müşteri No',
      chooseCategory: 'Kategori Seçiniz',
      month: 'Ay',
      installment: 'Taksit',
      payeAmount: 'Ödeme Miktarı',
      remain: 'Kalan',
      payScope: 'Durum',
      productId: 'Finansman Planı Numarası',
      customer: 'Müşteri',
      amount: 'Tutar',
      bargainAmount: 'Peşinat',
      installmentAmount: 'Taksit',
      actions: 'İşlemler',
      status: 'Durum',
      continue: 'Devam Eden',
      finished: 'Tamamlanmış',
      id: 'Id',
      agent: 'Temsilci',
      purpose: 'Amaç',
      category: 'Kategori',
      deliveryDate: 'Tahsisat Tarihi',
      workingCost: 'Organizasyon Ücreti',
      initial: 'Başlangıç',
      success: 'Başarılı',
      deleted: 'Silindi',
      identificationNumber: 'TCKN',
      customerName: 'Kullanıcı Adı',
      phoneNumber: 'Telefon Numarası',
      financeType: 'Finansman Türü',
      financeDetailType: 'Finansman Detay',
      methodType: 'Metod Türü',
      financeAmount: 'Finansman Tutarı',
      proposeUser: 'Finansman Planlama Uzmanı',
      productUser: 'Ürüne Çeviren'
    },
    ordered: {
      joker: 'Joker',
      deleteText: 'Silme işleminden emin misiniz?',
      deleteTitle: 'Sİlme İşlemi !!!',
      closeProductText: 'Tasarruf programı sonlnadırılacak... Emin misiniz?',
      closeProductTitle: 'Tasarruf Programı Sonlandırma',
      cloneProductText: 'Tasarruf programı sonlnadırılıp aynı özelliklerde yenisi başlatılacak... Emin misiniz?',
      cloneProductTitle: 'Tasarruf Programı Yeniden Başlatma',
      jokerRatio: 'Joker Yüzdesi',
      jokerCount: 'Joker Sayısı',
      advance: 'Avantaj Paketleri',
      program: 'Tasarruf Programı',
      status: 'Durum',
      group: 'Grup',
      setOrder: 'Noter Çekiliş Kura Sonucu Tanımlama',
      removeOrder: 'Kurayı Kaldır',
      version: 'Versiyonları',
      package: 'Erken Gel Paketler',
      drawingDate: 'Kura Çekiliş Tarihi',
      financeType: 'Finansman Türü',
      financeDetailType: 'Finansman Detay',
      autoClone: 'Otomatik Yenile',
      close: 'Programı Sonlandır',
      closeAndClone: 'Bu Programın Yenisini Başlat',
      deliveryDate: 'Standart Tahsisat Ayı',
      exactDeliveryDate: 'Kura Sonucu Teslim Ayı',
      drawingIsNotValid: 'Kura Sonucu Geçerli Değil',
      postponeCountAndTermNotValid: 'Taksit atlatma dönemi veya sayısı geçerli değil',
      drawingLaterThanCurrentDate: 'Kura Sonucu belirlenen tahsisat tarihinden sonra olamaz.',
      drawingOrder: 'Kura Sırası',
      drawingAlreadyAssigned: 'Bu kura sırasının hali hazırda sahibi var',
      printDrawCanditates: 'Sıra Tespit Listesi Yazdır',
      productCard: 'Finansman Planı Kartına Git',
      paymentPlan: 'Ödeme Planı'
    },
    freeplan: {
      quota: 'Kota',
      name: 'Finansman Planı Adı',
      minimumFinanceAmount: 'Minimum Tutar',
      maximumFinanceAmount: 'Maksimum Tutar',
      maturity: 'Vade',
      maturityRange: 'Vade Aralığı',
      advance: 'Avantaj Paketleri',
      group: 'Grup',
      version: 'Versiyonları',
      package: 'Erken Gel Paketler',
      financeType: 'Finansman Türü',
      financeDetailType: 'Finansman Detay',
      financeAmountRange: 'Finansman Planı Tutar Aralığı',
      validatefinanceAmount: 'Finasman Aralığı hatalı...',
      validateMaturityRange: 'Vade Aralığı hatalı...'
    }
  },
  revision: {
    errorMaxSkipCount: 'Maksimum atlatılabilecek taksit sayısı, grup vadesinden fazla bir değer olamaz',
    errorPerActionSkipCount: 'Bir defada atlatılabilecek taksit sayısı, max atlatılabilecek toplam taksit sayısından fazla olamaz.',
    currentFinanceAmount: 'Mevcut Finansman Tutarı',
    currentInstallmentAmount: 'Mevcut Taksit Tutarı',
    currentPaymentTotal: 'Toplam Ödeme',
    currentFirstPayment: 'Peşinat Ödemesi',
    currentTerm: 'Taksit Dönemi',
    totalTerm: 'Toplam Taksit Sayısı',
    group: 'Tasarruf Programı',
    deliveryDate: 'Teslim Ayı',
    currentWorkingCost: 'Mevcut Organizasyon Ücreti',
    financeAmount: 'Finansman Tutar Revizyonu',
    installment: 'Taksit Tutar Revizyonu',
    interim: 'ARA Ödeme',
    newFinanceAmount: 'Yeni Finansman Tutarı',
    newInstallment: 'Yeni Taksit Tutarı',
    newCalculationRequired: '%20 den fazla revizyon olduğundan yeni tasarruf programı hesaplaması yapılması gerekmemktedir.',
    newCalculation: 'Revize Program Tanımla',
    calculate: 'Hesapla',
    workingCost: 'Organizasyon Ücreti',
    interimPayment: 'Ara Ödeme'
  },
  productCard: {
    revision: 'Yeniden Yapılandırma',
    suspendDrawing: 'Sıra Tespitini Beklemeye Al',
    cancel: 'İptal Talebi',
    financeAmount: 'Finansman Tutarı',
    financeType: 'Finansman Türü',
    financeDetailType: 'Finansman Detay',
    financeCost: 'Organizasyon Ücreti',
    advanceAmount: 'Peşinat Tutarı',
    productName: 'Finansman Planı Adı',
    skipInstallment: 'Taksit Atlatma',
    campaign: 'Kampanya',
    package: 'Paket',
    projectNo: 'Finansman Planı Numarası',
    groupNo: 'Program No/Sıra No',
    navigate: 'Finansman Planı Kartına Git',
    customerCard: 'Müşteri Kartı',
    installmentAdvantage: 'Peşinat Avantajı',
    deliveryStatus: 'Tahsisat Durumu',
    productStatus: 'Finansman Planı Durumu',
    saveProduct: 'Teklifi Ürünleştir'
  },
  draw: {
    drawingTerm: 'Dönem',
    drawingTermPH: 'Dönemi seçiniz.',
    date: 'Tarihi',
    datePH: 'Kura tarihini seçiniz.',
    address: 'Adres',
    realJoker: 'Gerçek kişi - Joker',
    addressPH: 'Adresi giriniz.',
    place: 'Sıra Tespit Yeri',
    placePH: 'Kura Tespit Yeri seçiniz.',
    hour: 'Saati',
    hourPH: 'Kura Tespit Saati seçiniz.',
    firstDrawing: 'İlk Sıra Tespit Tarihi',
    order: 'Kaçıncı sıra Tespiti',
    group: 'Grup',
    removeDrawing: 'Kura Tespiti İptali',
    removeDrawingText: 'Kura Tespiti iptal edilecek emin misiniz?'
  }
};